import { gql } from '@apollo/client';

export const UPDATE_FINANCIAL_PRODUCT_FILTERS = gql`
  mutation updateFinancialProductFilters($input: FinancialProductFiltersInput) {
    updateFinancialProductFilters(input: $input) {
      commandId
      correlationId
    }
  }
`;
